import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import AOS from "aos";
import '@/common/css/common.less'
import './utils/ant.js'
import 'aos/dist/aos.css'
import './common/css/animate.min.css'
import "swiper/css/swiper.min.css"

AOS.init({
  duration: 1000,
  once: true
});


const bus = new Vue();
Vue.prototype.$bus = bus
Vue.prototype.$AOS = AOS;
Vue.config.productionTip = false

// 路由守卫
router.beforeEach((to, from, next) => {
  next()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
